module.exports = __webpack_public_path__ + "img/lead-11e.c0a07a0f.png";